import React from 'react';
import NPPanel from '../../NPPanel';
import { Button, Form, FormGroup, FormControl, Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faCheck } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import constants from '../.././util/constants';
import BannerSettings from './BannerSettings';
import TwoFactorSettings from './TwoFactor';
import { hasGrant } from '../../util/grantHelper'
import * as Grants from '../../util/grants';

const { API_BASE_URL } = constants;

class GlobalSettings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            header: {
                'Authorization': 'Bearer ' + this.props.apiToken,
                'Accept': 'application/octet-stream'
            },
            imagePath: null,
            showError: false,
            errorMessage: null,
            success: false
        }
        this.handleChangePath = this.handleChangePath.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.updateImagePath = this.updateImagePath.bind(this);

    }

    componentDidMount() {
        this.getImagePath();
    }

    handleChangePath(event) {
        this.setState({ imagePath: event.target.value })
    }

    getImagePath() {
        axios.get(API_BASE_URL + `Admin/GetImagePath`, { headers: this.state.header })
            .then(response => {
                let data = response.data;
                this.setState({ imagePath: data, showError: false })
            })
            .catch(error => {
                let data = error.response.data;
                this.setState({ showError: true, success: false, errorMessage: data.Message });
            });
    }

    updateImagePath() {
        axios.get(API_BASE_URL + `Admin/UpdateImagePath/?imagePath=${this.state.imagePath}`, { headers: this.state.header })
            .then(response => {
                let data = response.data;
                this.setState({ showError: false, success: true, successMessage: data });
            })
            .catch(error => {
                let data = error.response.data;
                this.setState({ showError: true, success: false, errorMessage: data.Message });
            });
    }


    render() {

        return (
            <NPPanel>
                <div className="create-user">
                    <section>
                        <div className="center-block text-center user-heading"> Global Settings </div>
                        <Form horizontal >
                            <FormGroup controlId="formHorizontalPath" bsSize="small">
                                <Row>
                                    <Col sm={6}>
                                        <label>Path to upload images</label>
                                        <FormControl type="text" placeholder="Path" value={this.state.imagePath ? this.state.imagePath : ''} onChange={this.handleChangePath} />
                                    </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                    <Col sm={12}>
                                        {this.state.success &&
                                            <div>
                                                <label>{this.state.successMessage}</label>
                                            </div>
                                        }
                                        {this.state.showError &&
                                            <div>
                                                <label className="danger">{this.state.errorMessage}</label>
                                            </div>
                                        }
                                        <Button bsStyle="primary" className="margin-left-10 pull-right" onClick={() => { this.updateImagePath(); }}>Update image path</Button>
                                    </Col>
                                </Row>
                            </FormGroup>
                        </Form>
                    </section>
                </div>

                <BannerSettings apiToken={this.props.apiToken} />
                {hasGrant(Grants.TYPES.Admin_EditTwoFactorSettings) && <TwoFactorSettings apiToken={this.props.apiToken} />}
            </NPPanel>
        );
    }
}
export default GlobalSettings;